import { Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { CONTACT_EMAIL } from 'src/constants';
import { RoleGuard } from 'src/services/user/RoleGuard';


export const Footer = () => {
  return (
    <RoleGuard disableForSuperAdmin roles={['ATTORNEY', 'FIRM_ADMIN']}>
      <Typography
        sx={{
          color: '#9AB1C0',
          fontSize: '13px',
          py: '12px',
          textAlign: 'center',
        }}
      >
        Need help? Contact your organization&apos;s administrator or email us at{' '}
        <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: '#356482' }}>
          {CONTACT_EMAIL}
        </a>
      </Typography>
    </RoleGuard>
  );
};
